// extracted by mini-css-extract-plugin
module.exports = {"filters":"ProjectsPage_filters__1-aT2","year":"ProjectsPage_year__1HBrR"};